<p-toast></p-toast>
<app-doc-summary-generation-select-dialog [showdialog]="showdialog" [selectedDocForSummary]="selectedDocForSummary"
    (emitSummaryForDoc)="emitSummary($event)" (closeDialog)="closeDialog($event)">
</app-doc-summary-generation-select-dialog>

<app-document-summary-sidebar
    *ngIf="dialogType === 'sideBar'"
    [sidebarVisible]="sidebarVisible"
    (emitSidebarUpdate)="updateSidebar($event)"
    [summaryData]="summaryData"
    [header]="headerSummary"
    [documentName]="summaryDocumentName"
    [documentModel]="documentModelForSummary"
></app-document-summary-sidebar>
<app-document-summary-dialog
    *ngIf="dialogType === 'documentSummary'"
    [sidebarVisible]="sidebarVisible"
    (emitSidebarUpdate)="updateSidebar($event)"
    [summaryData]="summaryData"
    [header]="headerSummary"
    [longSummaryType]="longSummaryType"
    [documentName]="summaryDocumentName"
    [documentModel]="documentModelForSummary"
></app-document-summary-dialog>
<app-confirmation-dialog [message]="dialogMessage" [display]="displayConfirmationDialog" [type]="displayDialogType"
    (accept)="ondialogaccept()" (cancel)="onCancelDialog()"></app-confirmation-dialog>
<app-fileupload-metadata-dialog [display]="displayCSVUploadDialog" [CSVFiles]="CSVFiles" [tableNames]="CSVTablesData"
    (accept)="this.displayCSVUploadDialog = false; submitFileUploadDialog($event)"
    (cancel)="this.displayCSVUploadDialog = false;  this.CSVFiles=[]; this.CSVTablesData = [] ;this.chatwithDocs = false"></app-fileupload-metadata-dialog>
<app-excel-tables-info [display]="displayExcelInfoDialog" (cancel)="closeInFoSlider($event)">
</app-excel-tables-info>


<p-tabView class="custom-tabview" [(activeIndex)]="activeTabIndex">
    <p-tabPanel header="Documents" class="pt-0">
        <div class="docContainer">
            <div class="flex justify-content-end">
                <div class="flexEnd">
                    <div class="p-input-icon-left searchContainer">
                        <i class="pi pi-search"></i>
                        <input pInputText class="searchInput p-inputtext pr-5" type="text"
                            (keydown)="this.searchTextUpdate.next($event)" [(ngModel)]="searchText"
                            placeholder="Search documents..." />
                        <i *ngIf="searchText?.length > 0"
                            (click)="searchText = ''; isloading=true;  docsList=[]; getAllDocs()"
                            class="pi pi-times cursor searchCancel"></i>
                    </div>
                    <input id="file" class="file-input pt-2" type="file"
                        accept=".pdf, .ppt, .pptx, .docx, .txt, .csv, .xlsx, .xls" (change)="fileSelect($event, false)"
                        #fileUpload multiple />
                    <button type="button" [disabled]="addingDocLoader" (click)="fileUpload.click()"
                        class="p-button p-button-outlined-secondary btnPadding cursor">
                        <span *ngIf="addingDocLoader" class="loaderSpinner mx-1"></span>
                        <i *ngIf="!addingDocLoader" class="bi bi-file-earmark mx-1"></i>
                        <span class="mr-1"> Add File</span>
                    </button>

                    <input id="folder" class="file-input pt-2" type="file"
                        accept=".pdf, .ppt, .pptx, .docx, .txt, .csv, .xlsx, .xls" (change)="fileSelect($event, true)"
                        #folderUpload multiple webkitdirectory />
                    <button type="button" [disabled]="addingFolderLoader" (click)="folderUpload.click()"
                        class="p-button p-button-outlined-secondary btnPadding cursor">
                        <span *ngIf="addingFolderLoader" class="loaderSpinner mx-1"></span>
                        <i *ngIf="!addingFolderLoader" class="bi bi-folder mx-1"></i>
                        <span class="mr-1"> Add Folder</span>
                    </button>
                    <button type="button"
                        [disabled]="selectedDocs.length === 0 || addingDocLoader || addingFolderLoader"
                        (click)="checkChatDocs()" class="p-button p-button-primary btnPadding">
                        <span *ngIf="chatwithDocs" class="loaderSpinnerWhite mr-2"></span>
                        Chat with Documents
                    </button>
                    <button *ngIf=" (selectedDocs.length>0 && !chatwithDocs)" type="button"
                        [disabled]="addingDocLoader || addingFolderLoader" (click)="deleteSelectedConfirmationDialog()"
                        class="p-button p-button-outlined-danger btnPadding mr-0 cursor">
                        <i class="bi bi-trash mx-1"></i>
                    </button>
                </div>
            </div>

            <div>
                <div *ngIf="isloading" class="loadingContainer">
                    <app-loader [isLoading]="isloading"></app-loader>
                </div>
                <!-- <q-loader></q-loader> -->
                <div class="ngTable" (scroll)="scrollUpdate.next($event)" *ngIf="!isloading && activeTabIndex === 0">
                    <p-table [columns]="displayedColumns" [value]="organizedDocsList" scrollHeight="calc(100vh - 280px)"
                        (onRowSelect)="onRowSelect($event)" (onRowUnselect)="onRowUnselect($event)"
                        [(selection)]="selectedDocs">
                        <ng-template pTemplate="header" let-columns>
                            <tr>
                                <th class="checkbox">
                                    <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                                </th>
                                <th class="nameCol">File</th>
                                <th class="csvIcon"></th>
                                <th>Status</th>
                                <th class="aboutCol-width">About</th>
                                <!-- <th class="uploadedBy">Uploaded By</th> -->
                                <th>Uploaded At</th>
                                <th>Summary</th>
                                <th>Actions</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
                            <tr [pSelectableRow]="rowData.documentId">
                                <td>
                                    <p-tableCheckbox [value]="rowData" [disabled]="
               (rowData.documentStatus === documentArchived &&
               (excelType.includes(rowData.contentType) || csvType.includes(rowData.contentType)))"></p-tableCheckbox>
                                </td>
                                <td tooltipPosition="top" pTooltip="{{ rowData?.documentName | titlecase }}"
                                    class="nameCol cursor">
                                    <div *ngIf="rowData.type === 'Folder'" (click)="toggleFolder(rowData.documentId)"
                                        class="folder-icon">
                                        <i class="bi bi-folder-fill folderColor"
                                            *ngIf="!expandedFolders[rowData.documentId]"></i>
                                        <i class="pi pi-folder-open folderColor"
                                            *ngIf="expandedFolders[rowData.documentId]"></i>
                                        {{ rowData.documentName }}
                                    </div>
                                    <div *ngIf="rowData.type === 'file'">{{ rowData.documentName.length > 40 ?
                                        (rowData.documentName |
                                        slice : 0 : 38) + '...' : rowData.documentName }}</div>
                                </td>
                                <td class="cursor">
                                    <i *ngIf="excelType.includes(rowData.contentType) || csvType.includes(rowData.contentType)"
                                        class="bi bi-table"></i>
                                </td>
                                <td>
                                    <div *ngIf="rowData.type === 'file' else folderStatus"
                                        [ngClass]="getDocStatusClass(rowData)">
                                        <div class="px-1" tooltipPosition="top"
                                            pTooltip="{{ rowData?.documentStatus | titlecase }}">
                                            {{ rowData?.documentStatus | titlecase }}
                                        </div>
                                    </div>
                                    <ng-template #folderStatus>
                                        <span>-</span>
                                    </ng-template>
                                </td>
                                <td class="aboutCol-width">
                                    <div class="cursor" (click)="showAbout(rowData)"
                                        *ngIf="((rowData.shortSummary || rowData.dataDictionary) && rowData.documentStatus !== documentProcessing) else noData">
                                        <ng-container *ngIf="rowData.dataDictionary">
                                            <span class="hyperlink"> Click here to see data dictionary </span>
                                        </ng-container>
                                        <ng-container *ngIf="!rowData.dataDictionary">
                                            {{ truncateSummary(rowData.shortSummary, 100) }}
                                        </ng-container>
                                        <ng-container *ngIf="rowData.type === 'Folder'">
                                            <span>-</span>
                                        </ng-container>
                                    </div>
                                    <ng-template #noData>
                                        <div *ngIf="rowData.documentStatus === documentProcessing">
                                            <i class="loaderSpinner"></i>
                                        </div>
                                        <div *ngIf="rowData.documentStatus !== documentProcessing" class="flex pl-4">
                                            -
                                        </div>
                                    </ng-template>
                                </td>
                                <!-- <td class="uploadedBy">
                                    <div class="userName-chip">
                                        <div tooltipPosition="top" pTooltip="{{ rowData?.creatorName }}">
                                            {{ getInitials(rowData.creatorName) | slice: 0 : 2 }}
                                        </div>
                                    </div>
                                </td> -->
                                <td>{{ rowData.createdAt | date: 'dd MMM yyyy HH:mm' }}</td>
                                <td>
                                    <div class="flex justify-content-start align-items-center">
                                        <div [ngClass]="getButtonClass(rowData)" tooltipPosition="top"
                                            pTooltip="{{ rowData?.summaryStatus | titlecase }}">
                                            <i (click)="openSummarySidebar(rowData)"
                                                *ngIf="(showSummary(rowData?.summaryStatus) || showFailedSummary(rowData?.summaryStatus) || showProcessingSummary(rowData?.summaryStatus)) && !rowData['loader']"
                                                class="bi bi-file-earmark-check-fill"></i>
                                            <i *ngIf="rowData['loader']" class="loaderSpinner"></i>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div class="me-1 docactions">
                                        <i (click)="openRetriggerConfirmation(rowData, rowIndex)"
                                            class="bi bi-arrow-clockwise reload mr-1 retryDoc"
                                            [ngClass]="rowData.documentStatus !== documentFailed || (excelType.includes(rowData.contentType) || csvType.includes(rowData.contentType)) ? 'visibilityHidden' : ''"
                                            pTooltip="Retry" tooltipPosition="top"></i>
                                        <i class="bi bi-play mr-1 docSummary cursor"
                                            [class.disabled-icon]="(rowData.documentStatus !== documentProcessed && rowData.documentStatus !== documentArchived) || (rowData.summaryStatus && rowData.summaryStatus === 'processing') || excelType.includes(rowData.contentType) || csvType.includes(rowData.contentType) || (rowData.type && rowData.type === 'Folder')"
                                            [disabled]="true" tooltipPosition="top" pTooltip="Generate Summary"
                                            (click)="openDialog(rowData)"></i>
                                            <!-- <span (click)="generateDocUpdates(rowData,rowIndex)">
                                            <img
                                                *ngIf="nonStructuredType.includes(rowData.contentType) && ((!rowData.documentRevisionsStatus || (rowData.documentRevisionsStatus !== summaryCompleted && rowData.documentRevisionsStatus !== summaryProcessing)) && !rowData.documentRevisions)"
                                                [class.disabled-icon]="(rowData.documentStatus !== documentProcessed && rowData.documentStatus !== documentArchived) || (rowData.summaryStatus && rowData.summaryStatus === 'processing') || excelType.includes(rowData.contentType) || csvType.includes(rowData.contentType)"
                                                [attr.disabled]="true"
                                                tooltipPosition="top"
                                                pTooltip="Identify Document Revisions"
                                                src="assets/images/documentRevisions.svg"
                                                width="18"
                                                height="18"
                                                alt="Pencil Square"
                                                class="mr-1 docSummary cursor"
                                            /></span> -->

                                        <!-- <i class="bi bi-file-check mr-1 docSummary cursor"
                                            *ngIf="nonStructuredType.includes(rowData.contentType)&&((!rowData.documentRevisionsStatus || (rowData.documentRevisionsStatus !== summaryCompleted && rowData.documentRevisionsStatus !== summaryProcessing)) && !rowData.documentRevisions)"
                                            [class.disabled-icon]="(rowData.documentStatus !== documentProcessed && rowData.documentStatus !== documentArchived) || (rowData.summaryStatus && rowData.summaryStatus === 'processing') || excelType.includes(rowData.contentType) || csvType.includes(rowData.contentType)"
                                            [disabled]="true" tooltipPosition="top" pTooltip="Identify Document Revisions"
                                            (click)="generateDocUpdates(rowData,rowIndex)"></i> -->
                                        <i class="bi bi-file-earmark-break mr-1 docSummary cursor" *ngIf="rowData.documentRevisionsStatus === summaryCompleted && rowData.documentRevisions"
                                            [disabled]="true" tooltipPosition="top" pTooltip="Document Revisions"
                                            (click)="showDocumentUpdates(rowData)"></i>
                                        <i *ngIf="(this.docLoaders[rowData.documentId] && this.docLoaders[rowData.documentId]['deleteLoader'] === true) || rowData.documentRevisionsStatus === summaryProcessing "
                                            class="loaderSpinner mr-2"></i>
                                        <i *ngIf="!(this.docLoaders[rowData.documentId] && this.docLoaders[rowData.documentId]['deleteLoader'] === true)"
                                            pTooltip="Delete" tooltipPosition="top"
                                            (click)="deleteConfirmationDialog(rowData, rowIndex)"
                                            class="bi bi-trash mr-2 cursor docDelete"></i>
                                    </div>
                                </td>
                            </tr>
                            <tr *ngIf="rowData.type === 'Folder' && expandedFolders[rowData.documentId]">
                                <td colspan="9" class="nested-files">
                                    <p-table [columns]="displayedColumns" [value]="rowData['files']"
                                        scrollable="true"
                                        scrollHeight="calc(100vh - 420px)" [(selection)]="selectedDocs"
                                        class="custom-table-style">
                                        <ng-template pTemplate="body" let-fileRow let-columns="columns"
                                            let-fileRowIndex="fileRowIndex">
                            <tr>

                                <td class="checkboxcol-nested" >
                                    <div class="flex">
                                    <p-tableCheckbox [value]="fileRow" [disabled]="
                          (fileRow.documentStatus === documentArchived &&
                          (excelType.includes(fileRow.contentType) || csvType.includes(fileRow.contentType)))">
                                    </p-tableCheckbox>
                                    </div>
                                </td>
                                <td  class="nameCol-nested" tooltipPosition="top" pTooltip="{{ fileRow?.documentName | titlecase }}"
                                    >
                                    <div class="flex mx-2 mt-1">
                                        {{ fileRow.documentName.length > 40 ? (fileRow.documentName | slice : 0 : 38) +
                                        '...' : fileRow.documentName }}
                                        <i *ngIf="excelType.includes(fileRow.contentType) || csvType.includes(fileRow.contentType)"
                                            class="bi bi-table tableIcon"></i>
                                    </div>
                                </td>
                                <!-- <td>
        <i *ngIf="excelType.includes(fileRow.contentType) || csvType.includes(fileRow.contentType)"
            class="bi bi-table"></i>
    </td> -->
                                <td class="statusCol-nested mr-2">
                                    <div [ngClass]="getDocStatusClass(fileRow)">
                                        <div class="px-1" tooltipPosition="top"
                                            pTooltip="{{ fileRow?.documentStatus | titlecase }}">
                                            {{ fileRow?.documentStatus | titlecase }}
                                        </div>
                                    </div>
                                </td>
                                <td class="aboutCol-width-nested">
                                    <div class="cursor" (click)="showAbout(fileRow)"
                                        *ngIf="((fileRow.shortSummary || fileRow.dataDictionary) && fileRow.documentStatus !== documentProcessing) else noData">
                                        <ng-container *ngIf="fileRow.dataDictionary">
                                            <span class="hyperlink"> Click here to see data dictionary </span>
                                        </ng-container>
                                        <ng-container *ngIf="!fileRow.dataDictionary">
                                            {{ truncateSummary(fileRow.shortSummary, 100) }}
                                        </ng-container>
                                    </div>
                                    <ng-template #noData>
                                        <div *ngIf="fileRow.documentStatus === documentProcessing">
                                            <i class="loaderSpinner"></i>
                                        </div>
                                        <div *ngIf="fileRow.documentStatus !== documentProcessing" class="flex pl-4">-
                                        </div>
                                    </ng-template>
                                </td>
                                <!-- <td class="uploadedBy-nested mr-1">
                                    <div class="userName-chip">
                                        <div tooltipPosition="top" pTooltip="{{ fileRow?.creatorName }}">
                                            {{ getInitials(fileRow.creatorName) | slice: 0: 2 }}
                                        </div>
                                    </div>
                                </td> -->
                                <td class="uploadedAtCol-nested">{{ fileRow.createdAt | date: 'dd MMM yyyy HH:mm' }}</td>
                                <td class="summaryCol-nested">
                                    <div class="flex justify-content-start align-items-center">
                                        <div [ngClass]="getButtonClass(fileRow)" tooltipPosition="top"
                                            pTooltip="{{ fileRow?.summaryStatus | titlecase }}">
                                            <i (click)="openSummarySidebar(fileRow)"
                                                *ngIf="(showSummary(fileRow?.summaryStatus) || showFailedSummary(fileRow?.summaryStatus) || showProcessingSummary(fileRow?.summaryStatus)) && !fileRow['loader']"
                                                class="bi bi-file-earmark-check-fill"></i>
                                            <i *ngIf="fileRow['loader']" class="loaderSpinner"></i>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div class="me-1 docactions">
                                        <i (click)="openRetriggerConfirmation(fileRow, fileRowIndex)"
                                            class="bi bi-arrow-clockwise reload mr-1 retryDoc"
                                            [ngClass]="fileRow.documentStatus !== documentFailed || (excelType.includes(fileRow.contentType) || csvType.includes(fileRow.contentType)) ? 'visibilityHidden' : ''"
                                            pTooltip="Retry" tooltipPosition="top"></i>
                                        <i class="bi bi-play mr-1 docSummary cursor"
                                            [class.disabled-icon]="(fileRow.documentStatus !== documentProcessed && fileRow.documentStatus !== documentArchived) || (fileRow.summaryStatus && fileRow.summaryStatus === 'processing') || excelType.includes(fileRow.contentType) || csvType.includes(fileRow.contentType)"
                                            [disabled]="true" tooltipPosition="top" pTooltip="Generate Summary"
                                            (click)="openDialog(fileRow)"></i>
                                        <!-- <i class="bi bi-file-check mr-1 docSummary cursor"
                                          *ngIf="nonStructuredType.includes(fileRow.contentType)&&((!fileRow.documentRevisionsStatus || (fileRow.documentRevisionsStatus !== summaryCompleted && fileRow.documentRevisionsStatus !== summaryProcessing)) && !fileRow.documentRevisions)"
                                            [class.disabled-icon]="(fileRow.documentStatus !== documentProcessed && fileRow.documentStatus !== documentArchived) || (fileRow.summaryStatus && fileRow.summaryStatus === 'processing') || excelType.includes(fileRow.contentType) || csvType.includes(fileRow.contentType)"
                                            [disabled]="true" tooltipPosition="top" pTooltip="Identify Document Revisions"
                                            (click)="generateDocUpdates(fileRow,rowIndex)"></i> -->
                                        <i class="bi bi-file-earmark-break mr-1 docSummary cursor" *ngIf="fileRow.documentRevisionsStatus === summaryCompleted && fileRow.documentRevisions"
                                            [disabled]="true" tooltipPosition="top" pTooltip="Document Revisions"
                                            (click)="showDocumentUpdates(fileRow)"></i>
                                        <i *ngIf="(this.docLoaders[rowData.documentId] && this.docLoaders[rowData.documentId]['deleteLoader'] === true) || fileRow.documentRevisionsStatus === summaryProcessing "
                                            class="loaderSpinner mr-2"></i>
                                        <i *ngIf="!(this.docLoaders[fileRow.documentId] && this.docLoaders[fileRow.documentId]['deleteLoader'] === true)"
                                            pTooltip="Delete" tooltipPosition="top"
                                            (click)="deleteConfirmationDialog(fileRow, fileRowIndex)"
                                            class="bi bi-trash mr-2 cursor docDelete"></i>
                                        <i *ngIf="(this.docLoaders[fileRow.documentId] && this.docLoaders[fileRow.documentId]['deleteLoader'] === true)"
                                            class="loaderSpinner mr-2"></i>
                                    </div>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                    </td>
                    </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage" class="emptymessage">
                        <tr>
                            <td colspan="12">
                                <div class="noData">No Document Available</div>
                            </td>
                        </tr>
                    </ng-template>
                    </p-table>
                </div>
                <div *ngIf="loadmoreLoading && docsList.length > 0 && !isloading" class="flexEnd load-more mt-1">
                    Loading...
                </div>
            </div>
        </div>
    </p-tabPanel>
    <p-tabPanel header="ESG Data">
      <div class="docContainer" *ngIf="activeTabIndex === 1">
       <app-esgdata-main></app-esgdata-main>
      </div>
    </p-tabPanel>
    <p-tabPanel *availableFor header="QEC Data">
        <div class="docContainer" *ngIf="activeTabIndex === 2">
            <app-tables-main></app-tables-main>
        </div>
    </p-tabPanel>
    <ng-template availableFor [isAdminPage]="true">
    <p-tabPanel header="Usage Statistics">
      <div class="docContainer" *ngIf="activeTabIndex === 3">
        <div class="usageStats"><app-admin></app-admin></div>
      </div>
  </p-tabPanel>
  </ng-template>




</p-tabView>
